import { AfterViewInit, Component, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import swal from 'sweetalert2';
import { DataService } from '../../../../services/data.service';
import { IssueService } from '../../../../services/issue.service';
import { getQueryParamFromAncestorRoute } from '../../../../utilities/route.utilities';

@Component({
    selector: 'issue-read-data-availability-consumption-grid-item',
    templateUrl: './issues-read-data-availability-consumption-grid-item.component.html',
})
export class IssuesReadDataAvailabilityConsumptionComponent implements AfterViewInit, OnDestroy {

    clientId: number;
    subscriptions: any[] = [];
    data: any[] = [];
    page: number = 1;
    totalPages: number = 1;
    pageSize: number = 10;
    siteId: number;

    constructor(private issueService: IssueService,
        private route: ActivatedRoute,
        private router: Router,
        private dataService: DataService) { }

    ngAfterViewInit() {
        this.subscriptions.push(this.route.queryParams.subscribe(queryParams => {
            this.onInitialise();
        }));
    }

    onInitialise() {
        this.clientId = this.route.parent.parent.snapshot.params['clientId'];
        this.siteId = getQueryParamFromAncestorRoute(this.route, 'siteId');

        this.subscriptions.push(this.route
            .queryParams
            .subscribe(queryParams => {
                if (+queryParams['readDataAvailabilityConsumptionPage']) {
                    this.page = +queryParams['readDataAvailabilityConsumptionPage'];
                } else { this.page = 1 }
            }));

        this.getData();       
    }

    ngOnDestroy() {
        this.subscriptions.forEach(s => s.unsubscribe());
    }

    isValidDate(item: any): boolean {
        let date = new Date(item.latestBillDate);
        let yearString = date.getFullYear().toString();
        if (yearString === "1" || item.latestBillDate == null) {
            return false;
        } else {
            return true;
        }
    }

    getPage(page: number) {
        this.page = page;
        this.getData();
    }

    getData() {
        this.issueService.getReadDataAvailabilityConsumptionDetail(this.clientId, this.page, this.pageSize, this.siteId).then((result) => {
            this.data = [];
            if (result && result.items && result.items.length > 0) {
                this.data = result.items;
                this.totalPages = result.totalPages;
                this.pageSize = result.pageSize;
                this.page = result.currentPage;
            } else { this.dataService.issuesReadDataAvailabilityComponentResolved.next(false); }
        }, error => this.dataService.issuesReadDataAvailabilityComponentResolved.next(false)
        )
    }

    onInfoClick() {
        swal({
            title: 'Meter reading frequency in last 60 days',
            html: '<p style="text-align: left;">This widget considers the availability of readings in last 60 days. Here we would like to understand any meters that are failing to communicate intermittently as this could mean the meter / data collection equipment needs attention, repair or replacement.</p>\
            <p style="text-align: left;">We have an expectation that meters should communicate at minimum once a day; of course, there are some exceptions to this rule depending on the equipment installed.</p>\
            <p style="text-align: left;">Speak to our customer services team about this. We are here to help.</p>',
            confirmButtonText: 'Close',
            confirmButtonColor: '#00539f'
        });
    }
}
